// import Vue from 'vue';
import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';

import { ENTRANCE } from '@/_redesign/modules/Entrance/routes/entrance';
import { SIGNUP } from '@/_redesign/modules/Onboarding/routes';
import { TRANSFERS } from '@/_redesign/modules/Transfers/routes';
import { MERCHANT_DASHBOARD, UNIVERSAL_DASHBOARD, USER_DASHBOARD } from '@/_redesign/modules/UserDashboard/routes';
import { MAINTENANCE } from '@/modules/maintenance/routes';
import { MEDIA_FILES } from '@/modules/media-files/routes';
import { ONBOARDING } from '@/modules/onboarding/routes/onboarding';
// import { SIGNUP } from '@/modules/onboarding/routes/signup';
import { PRE_ASSESSMENT } from '@/modules/pre-assessment/routes';
import middlewarePipeline from '@/router/middlewarePipeline';
import { defaultGuard } from '@/router/middlewares/defaultGuard';
import { permissionGuard } from '@/router/middlewares/permissionGuard';

import { DASHBOARD } from './dashboard';
import { saveBackRoutes } from './middlewares/saveBackRoutes';

const routes: RouteRecordRaw[] = [
  ENTRANCE,
  PRE_ASSESSMENT,
  DASHBOARD,
  USER_DASHBOARD,
  UNIVERSAL_DASHBOARD,
  MERCHANT_DASHBOARD,
  MAINTENANCE,
  SIGNUP,
  TRANSFERS,
  ONBOARDING,
  MEDIA_FILES,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  /*
  ** TEMPORARY SOLUTION to avoid scrolling to top on page change
  ** TODO: uncomment and use savedPosition or hash for merchant dashboard
  **
  // @ts-ignore
  scrollBehavior(to: RouteLocation, from: RouteLocation, savedPosition: Position | void): any {

    if (savedPosition) {
      return savedPosition;
    }

    if (to.params?.viewPosition) {
      return to.params.viewPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash,
      };
    }

    return { x: 0, y: 0 };
  },
  */
});

router.beforeEach((to, from, next) => {
  const middleware = to?.meta?.middleware || [];

  const middlewares = [...middleware, defaultGuard, permissionGuard, saveBackRoutes];
  const context = {
    to,
    from,
    next,
    abort: next,
  };

  return middlewares[0]({
    ...context,
    next: middlewarePipeline(context, middlewares, 1),
  });
});

router.onError((error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed')) {
    if (!to?.fullPath) {
      window.location.reload();
    } else {
      window.location.href = to.fullPath;
    }
  }
});

export default router;
